// extracted by mini-css-extract-plugin
export var scrollArea = "_ow-0";